var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBluesky = function SvgIconBluesky(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.119 1.163C6.297 2.85 8.64 6.275 9.5 8.112v4.852c0-.103-.039.014-.122.265-.449 1.362-2.202 6.675-6.211 2.428-2.111-2.237-1.134-4.473 2.709-5.149-2.199.386-4.67-.252-5.348-2.754C.333 7.034 0 2.6 0 2c0-3 2.547-2.057 4.119-.838m10.763 0C12.702 2.85 10.36 6.275 9.5 8.112v4.852c0-.103.039.014.122.265.449 1.362 2.202 6.675 6.211 2.428 2.111-2.237 1.134-4.473-2.709-5.149 2.199.386 4.67-.252 5.348-2.754C18.667 7.034 19 2.6 19 2c0-3-2.547-2.057-4.118-.838"
  })));
};
export default SvgIconBluesky;